/* LAMORE · motion: endless video rail marquee, auto-moving step carousel with progress, heading reveals. */
(function () {
  'use strict';
  var d = document, reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && 'IntersectionObserver' in window) d.documentElement.classList.add('lz-motion');

  function headings(root) {
    var hs = Array.prototype.slice.call((root || d).querySelectorAll('.lz-h2, .lz-buy__title'));
    if (!d.documentElement.classList.contains('lz-motion')) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.querySelectorAll('.lz-h2, .lz-buy__title').forEach(function (h) { h.classList.add('is-shown'); }); io.unobserve(e.target); } });
    }, { threshold: 0.1 });
    hs.forEach(function (h) { io.observe(h.parentElement); });
    setTimeout(function () { hs.forEach(function (h) { var r = h.parentElement.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) h.classList.add('is-shown'); }); }, 1500);
  }

  function auto(track, opts) {
    if (track.dataset.lzAuto) return; track.dataset.lzAuto = '1';
    var bar = d.createElement('div'); bar.className = 'lz-progress'; bar.setAttribute('aria-hidden', 'true');
    var fill = d.createElement('span'); bar.appendChild(fill); track.insertAdjacentElement('afterend', bar);
    function paint() {
      var sw = track.scrollWidth, cw = track.clientWidth;
      if (sw <= cw + 4) { bar.style.display = 'none'; return; }
      bar.style.display = '';
      fill.style.width = Math.max(10, cw / sw * 100) + '%';
      fill.style.left = (track.scrollLeft / sw * 100) + '%';
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(paint); }, { passive: true });
    window.addEventListener('resize', paint); paint(); setTimeout(paint, 800);
    if (reduce) return;
    var pausedUntil = 0, visible = false;
    function hold() { pausedUntil = Date.now() + 7000; }
    ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach(function (ev) { track.addEventListener(ev, hold, { passive: true }); });
    track.addEventListener('mouseenter', function () { pausedUntil = Date.now() + 4000; });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.3 }).observe(track);
    setInterval(function () {
      if (!visible || Date.now() < pausedUntil || d.hidden) return;
      if (d.querySelector('.lz-modal[open]')) return;
      var sw = track.scrollWidth, cw = track.clientWidth; if (sw <= cw + 4) return;
      var item = track.querySelector(opts.item); var step = item ? item.getBoundingClientRect().width + 12 : cw * 0.8;
      if (track.scrollLeft + cw >= sw - 8) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step, behavior: 'smooth' });
    }, opts.every || 3000);
  }

  /* ---------- video rail: endless right-to-left marquee that never stops ---------- */
  var cloneIO = null;
  function setupCloneVideo(v) {
    var start = parseFloat(v.dataset.start) || 0, end = parseFloat(v.dataset.end) || null;
    v.removeAttribute('data-lz-ready'); v.muted = true; v.loop = false;
    v.addEventListener('loadedmetadata', function () { if (start && v.currentTime < start) v.currentTime = start; });
    v.addEventListener('timeupdate', function () {
      var stop = end || (v.duration ? v.duration - 0.2 : null);
      if (stop && v.currentTime >= stop) v.currentTime = start;
    });
    v.addEventListener('ended', function () { v.currentTime = start; v.play().catch(function () {}); });
    if (!cloneIO) cloneIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var x = e.target;
        if (e.isIntersecting) { if (x.preload === 'none') x.preload = 'auto'; var p = x.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!x.paused) x.pause();
      });
    }, { threshold: 0.2 });
    cloneIO.observe(v);
  }

  var marqueeCss = false;
  function addMarqueeCss() {
    if (marqueeCss) return; marqueeCss = true;
    var st = d.createElement('style');
    st.textContent =
      '.lz-rail.lz-marquee{overflow:hidden;scroll-snap-type:none}' +
      '.lz-marquee .lz-rail__track{padding:0;will-change:transform;animation:lz-marquee var(--lz-dur,60s) linear infinite}' +
      '.lz-marquee .lz-reel{scroll-snap-align:none}' +
      '.lz-marquee .lz-reel.lz-rise{opacity:1;transform:none}' +
      '[data-lz-reels].lz-has-marquee .lz-arrows{display:none}' +
      '@keyframes lz-marquee{from{transform:translate3d(0,0,0)}to{transform:translate3d(calc(-1 * var(--lz-loop,0px)),0,0)}}';
    d.head.appendChild(st);
  }

  function marquee(rail) {
    if (rail.dataset.lzAuto) return; rail.dataset.lzAuto = '1';
    var track = rail.querySelector('.lz-rail__track');
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    if (!items.length) return;
    addMarqueeCss();
    rail.classList.add('lz-marquee');
    var sec = rail.closest('[data-lz-reels]'); if (sec) sec.classList.add('lz-has-marquee');
    items.forEach(function (li) { li.classList.add('is-in'); });

    function addCopy() {
      items.forEach(function (li) {
        var c = li.cloneNode(true);
        c.setAttribute('aria-hidden', 'true'); c.classList.add('lz-reel--clone', 'is-in');
        c.removeAttribute('data-shopify-editor-block');
        c.querySelectorAll('a, [tabindex]').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
        c.querySelectorAll('video').forEach(setupCloneVideo);
        track.appendChild(c);
      });
    }
    var copies = 1, lastW = 0;
    function layout() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var setW = items[items.length - 1].getBoundingClientRect().right - items[0].getBoundingClientRect().left + gap;
      if (setW <= 0) return;
      /* enough copies that the strip always covers the screen while one set slides out */
      var need = Math.ceil(rail.clientWidth / setW) + 1;
      while (copies < need) { addCopy(); copies++; }
      var speed = window.matchMedia('(min-width: 990px)').matches ? 45 : 35; /* px per second */
      track.style.setProperty('--lz-loop', setW + 'px');
      track.style.setProperty('--lz-dur', (setW / speed) + 's');
      lastW = window.innerWidth;
    }
    layout(); rail.scrollLeft = 0;
    window.addEventListener('resize', function () { if (window.innerWidth !== lastW) layout(); });
    window.addEventListener('load', layout);
  }

  function boot(root) {
    root = root || d;
    headings(root);
    root.querySelectorAll('.lz-rail').forEach(marquee);
    root.querySelectorAll('.lz-steps__list').forEach(function (r) { auto(r, { item: '.lz-step', every: 3400 }); });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { boot(d); }); else boot(d);
  d.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
